import { useState } from 'react'
import { SelectSearchFieldParams } from '@templates/AddNewItemModal/templates/selectSearchField'
import { ReturnType } from '@app-types/riskMapFields'
import { FilterState } from '@hooks/useItemsFilters'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetMeasuresContentsQuery } from '@services/measuresContents'

const useMeasuresContentsField = (
  params: Partial<SelectSearchFieldParams>
): ReturnType => {
  const [filters, setFilters] = useState<FilterState | undefined>()

  return {
    setFilters,
    field: () =>
      dataSelectField({
        filters,
        query: useGetMeasuresContentsQuery,
        setFilters,
        dropdownWidth: 500,
        label: 'Содержание',
        name: 'measureContents',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        ...params,
      }),
  }
}

export default useMeasuresContentsField
